import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Signup from "@/pages/Signup";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import GoalCreate from "@/pages/GoalCreate";
import GoalDetail from "@/pages/GoalDetail";
import Pix from "@/pages/Pix";
import Goals from "@/pages/Goals";
import AdminLogin from "@/pages/AdminLogin";

const Loading = () => (
  <div data-testid="app-loading" className="grid min-h-screen place-items-center cofre-bg text-xl font-semibold text-emerald-900">
    Carregando...
  </div>
);

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to={admin ? "/adm/login" : "/entrar"} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/painel" replace />;
  return children;
};

const Gate = ({ children }) => {
  const { user } = useAuth();
  return user === null ? <Loading /> : children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors toastOptions={{ style: { fontSize: "18px" } }} />
        <Routes>
          <Route path="/" element={<Gate><Landing /></Gate>} />
          <Route path="/cadastro" element={<Gate><Signup /></Gate>} />
          <Route path="/entrar" element={<Gate><Login /></Gate>} />
          <Route path="/adm/login" element={<Gate><AdminLogin /></Gate>} />
          <Route path="/esqueci-senha" element={<ForgotPassword />} />
          <Route path="/painel" element={<Protected><Dashboard /></Protected>} />
          <Route path="/metas/nova" element={<Protected><GoalCreate /></Protected>} />
          <Route path="/metas" element={<Protected><Goals /></Protected>} />
          <Route path="/metas/:goalId" element={<Protected><GoalDetail /></Protected>} />
          <Route path="/meu-pix" element={<Protected><Pix /></Protected>} />
          <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
